import React, { Component } from "react";
import {
  withStyles,
  Box,
  Paper,
  Tabs,
  Tab,
  CircularProgress,
  Typography,
  Chip,
  Fab,
  Snackbar,
  SnackbarContent,
  TextField,
  InputAdornment,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Tooltip,
} from "@material-ui/core";
import {
  CropFree as QrCodeIcon,
  CheckCircle,
  Error,
  Search as SearchIcon,
  Clear as ClearIcon,
  CheckCircleOutline as CheckInIcon,
  OpenInNew as OpenInNewIcon,
  Receipt as ReceiptIcon,
} from "@material-ui/icons";
import MUIDataTable from "mui-datatables";
import axios from "axios";
import moment from "moment";
import QRScanner from "./QRScanner";
import { connect } from "react-redux";

const styles = (theme) => ({
  root: {
    padding: theme.spacing(3),
    maxWidth: "100%",
    margin: "0 auto",
    minHeight: "100vh", // ensures the page can extend and scroll
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2),
    },
  },
  header: {
    marginBottom: theme.spacing(3),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: theme.spacing(2),
  },
  title: {
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
  tabsContainer: {
    marginBottom: theme.spacing(3),
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    borderRadius: 12,
    overflow: "hidden",
  },
  tabs: {
    backgroundColor: "#fff",
    "& .MuiTabs-indicator": {
      height: 3,
      borderRadius: "3px 3px 0 0",
    },
  },
  tab: {
    textTransform: "none",
    fontWeight: 500,
    fontSize: "0.95rem",
    minHeight: 56,
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.85rem",
      minHeight: 48,
      padding: theme.spacing(1),
    },
  },

  // horizontal scroll wrapper for wide column sets
  tableScrollX: {
    width: "100%",
    overflowX: "auto",
    WebkitOverflowScrolling: "touch", // Smooth scrolling on iOS
    "&::-webkit-scrollbar": {
      height: 8,
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#f1f5f9",
      borderRadius: 4,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#cbd5e1",
      borderRadius: 4,
      "&:hover": {
        backgroundColor: "#94a3b8",
      },
    },
  },

  tablePaper: {
    backgroundColor: "#fff",
    position: "relative",
    // was overflow: hidden — that can trap vertical scroll.
    // keep Y visible so the page can scroll if needed.
    overflowX: "hidden",
    overflowY: "visible",
    borderRadius: 12,
    boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
    "& .MuiPaper-root": { boxShadow: "none" },

    // Force table to stay in table layout on mobile
    "& .MuiTable-root": {
      minWidth: "800px",
      [theme.breakpoints.down("sm")]: {
        minWidth: "800px", // Force horizontal scroll on mobile
      },
    },

    // Header cells: compact but readable
    "& .MuiTableHead-root .MuiTableCell-root": {
      fontWeight: 600,
      backgroundColor: "#f8fafc",
      color: theme.palette.text.primary,
      fontSize: "0.85rem",
      borderBottom: "2px solid #e2e8f0",
      paddingTop: 6,
      paddingBottom: 6,
      lineHeight: 1.25,
      height: 40,
      whiteSpace: "nowrap",
    },

    // Body cells: increase line-height a bit for readability
    "& .MuiTableCell-body": {
      fontSize: "0.875rem",
      lineHeight: 1.35, // ⬅️ slightly more breathing room
      paddingTop: theme.spacing(1.25), // ~10px
      paddingBottom: theme.spacing(1.25),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      whiteSpace: "nowrap", // Prevent text wrapping on mobile
      [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(1),
        fontSize: "0.8rem",
        lineHeight: 1.3,
      },
    },

    "& .MuiTablePagination-root": {
      borderTop: "1px solid #e2e8f0",
      "& .MuiTablePagination-toolbar": {
        justifyContent: "center",
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        [theme.breakpoints.down("sm")]: {
          flexWrap: "wrap",
          minHeight: 64,
        },
      },
      "& .MuiTablePagination-spacer": { display: "none" },
      "& .MuiTablePagination-caption": {
        [theme.breakpoints.down("sm")]: { fontSize: "0.75rem" },
      },
    },

    "& .MuiToolbar-root": {
      padding: theme.spacing(2),
      minHeight: "auto",
    },
  },

  loadingOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
    borderRadius: 12,
  },

  statusChip: {
    fontWeight: 500,
    fontSize: "0.75rem",
  },
  phoneText: {
    fontFamily: "monospace",
    fontSize: "0.85rem",
    whiteSpace: "nowrap",
  },
  amountText: {
    fontWeight: 600,
    color: "#059669",
  },

  // Floating Action Button styles
  fabContainer: {
    position: "fixed",
    zIndex: 1100,
    // Desktop: top right
    [theme.breakpoints.up("md")]: {
      top: theme.spacing(10),
      right: theme.spacing(3),
    },
    // Mobile: bottom center
    [theme.breakpoints.down("sm")]: {
      bottom: theme.spacing(3),
      left: "50%",
      transform: "translateX(-50%)",
    },
  },
  fab: {
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    color: "#fff",
    boxShadow: "0 4px 20px rgba(102, 126, 234, 0.4)",
    "&:hover": {
      background: "linear-gradient(135deg, #5568d3 0%, #65408b 100%)",
      boxShadow: "0 6px 24px rgba(102, 126, 234, 0.5)",
    },
    [theme.breakpoints.down("sm")]: {
      width: 64,
      height: 64,
    },
  },
  fabLabel: {
    marginLeft: theme.spacing(1),
    fontWeight: 600,
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },

  // Snackbar styles
  snackbarSuccess: {
    backgroundColor: "#4caf50",
    color: "#fff",
    fontSize: "0.95rem",
    fontWeight: 500,
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    boxShadow: "0 4px 12px rgba(76, 175, 80, 0.3)",
  },
  snackbarError: {
    backgroundColor: "#f44336",
    color: "#fff",
    fontSize: "0.95rem",
    fontWeight: 500,
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    boxShadow: "0 4px 12px rgba(244, 67, 54, 0.3)",
  },
  snackbarIcon: {
    marginRight: theme.spacing(1),
    fontSize: "1.25rem",
  },

  // Search bar styles
  searchContainer: {
    marginBottom: theme.spacing(3),
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      gap: theme.spacing(1.5),
    },
  },
  searchField: {
    flex: 1,
    backgroundColor: "#f8fafc",
    borderRadius: 12,
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#fff",
      borderRadius: 12,
      "& fieldset": {
        borderColor: "#cbd5e1",
        borderWidth: 2,
      },
      "&:hover fieldset": {
        borderColor: "#94a3b8",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#667eea",
        borderWidth: 2,
      },
    },
    "& .MuiInputBase-input": {
      padding: "12px 14px",
      fontSize: "0.95rem",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },

  // Manual check-in button styles
  checkInButton: {
    minWidth: 80,
    padding: "8px 16px",
    borderRadius: 8,
    fontWeight: 600,
    textTransform: "none",
    backgroundColor: "#10b981",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#059669",
    },
    "&.Mui-disabled": {
      backgroundColor: "#e2e8f0",
      color: "#94a3b8",
    },
    [theme.breakpoints.down("sm")]: {
      minWidth: 70,
      padding: "6px 12px",
      fontSize: "0.75rem",
    },
  },
  checkInIcon: {
    fontSize: "1.1rem",
    marginRight: theme.spacing(0.5),
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.9rem",
      marginRight: theme.spacing(0.3),
    },
  },

  // Confirmation dialog styles
  dialogTitle: {
    paddingBottom: theme.spacing(1),
  },
  dialogContent: {
    minWidth: 300,
    [theme.breakpoints.down("sm")]: {
      minWidth: 250,
    },
  },
  attendeeInfo: {
    padding: theme.spacing(2),
    backgroundColor: "#f8fafc",
    borderRadius: 8,
    marginTop: theme.spacing(2),
  },
  infoRow: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: theme.spacing(1),
    "&:last-child": {
      marginBottom: 0,
    },
  },
  infoLabel: {
    fontWeight: 600,
    color: theme.palette.text.secondary,
    fontSize: "0.9rem",
  },
  infoValue: {
    color: theme.palette.text.primary,
    fontSize: "0.95rem",
    textAlign: "right",
    wordBreak: "break-word",
    maxWidth: "60%",
  },

  // Attendee details dialog styles
  detailsDialogPaper: {
    borderRadius: 16,
    maxWidth: 600,
  },
  detailsDialogTitle: {
    backgroundColor: "#667eea",
    color: "#fff",
    padding: theme.spacing(2, 3),
  },
  detailsSection: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: "#f8fafc",
    borderRadius: 8,
    borderLeft: "4px solid #667eea",
  },
  sectionTitle: {
    fontWeight: 700,
    fontSize: "0.9rem",
    color: "#667eea",
    marginBottom: theme.spacing(1),
    textTransform: "uppercase",
    letterSpacing: 0.5,
  },
  clickableRow: {
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#f1f5f9 !important",
    },
  },
  // Transaction dialog styles
  transactionDialogPaper: {
    borderRadius: 16,
    maxWidth: 650,
    [theme.breakpoints.down("sm")]: {
      margin: theme.spacing(2),
      maxWidth: "calc(100% - 32px)",
    },
  },
  transactionDialogTitle: {
    backgroundColor: "#10b981",
    color: "#fff",
    padding: theme.spacing(2, 3),
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  transactionSection: {
    marginBottom: theme.spacing(2.5),
    padding: theme.spacing(2),
    backgroundColor: "#f8fafc",
    borderRadius: 8,
    borderLeft: "4px solid #10b981",
  },
  transactionSectionTitle: {
    fontWeight: 700,
    fontSize: "0.9rem",
    color: "#10b981",
    marginBottom: theme.spacing(1.5),
    textTransform: "uppercase",
    letterSpacing: 0.5,
  },
  transactionInfoRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: theme.spacing(1),
    flexWrap: "wrap",
    gap: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },
  transactionInfoLabel: {
    fontWeight: 600,
    color: "#64748b",
    fontSize: "0.875rem",
    minWidth: 140,
  },
  transactionInfoValue: {
    color: "#1e293b",
    fontSize: "0.875rem",
    flex: 1,
    textAlign: "right",
    wordBreak: "break-word",
    [theme.breakpoints.down("sm")]: {
      textAlign: "left",
    },
  },
  linkButton: {
    marginTop: theme.spacing(1),
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
    padding: theme.spacing(1, 2),
    borderRadius: 8,
    backgroundColor: "#e0f2fe",
    color: "#0284c7",
    textDecoration: "none",
    fontWeight: 500,
    fontSize: "0.875rem",
    transition: "all 0.2s",
    "&:hover": {
      backgroundColor: "#bae6fd",
      transform: "translateY(-1px)",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      justifyContent: "center",
    },
  },
});

const API_BASE_URL =
  process.env.REACT_APP_MODE === "production"
    ? "https://backend-agenda.aisensy.com/events/v1/"
    : process.env.REACT_APP_MODE === "staging"
    ? "https://backend-agenda.aisensy.com/stg/events/v1/"
    : "http://localhost:5006/events/v1/";

class EventDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: 0,
      rows: [],
      total: 0,
      page: 0,
      rowsPerPage: 10,
      loading: false,
      eventSlug: "aipersy",
      scannerOpen: false,
      scanResult: null,
      alreadyCheckedIn: false,
      snackbarOpen: false,
      snackbarMessage: "",
      snackbarSeverity: "info",
      // Search state
      searchQuery: "",
      searchDebounceTimer: null,
      // Manual check-in confirmation dialog
      confirmDialogOpen: false,
      selectedAttendee: null,
      checkingIn: false,
      // Attendee details dialog
      detailsDialogOpen: false,
      selectedAttendeeForDetails: null,
      // Transaction details dialog
      transactionDialogOpen: false,
      selectedTransaction: null,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.tab !== this.state.tab ||
      prevState.page !== this.state.page ||
      prevState.searchQuery !== this.state.searchQuery
    ) {
      if (
        prevState.tab !== this.state.tab ||
        prevState.searchQuery !== this.state.searchQuery
      ) {
        this.setState({ page: 0 }, this.fetchData);
      } else {
        this.fetchData();
      }
    }
  }

  fetchData = async () => {
    try {
      this.setState({ loading: true });
      const { tab, page, rowsPerPage, eventSlug, searchQuery } = this.state;

      let url = "";
      const params = {
        page: page + 1,
        limit: rowsPerPage,
        ...(searchQuery && { search: searchQuery }),
      };

      if (tab === 0) {
        url = `${API_BASE_URL}${eventSlug}/dashboard/customers`;
        params.filterType = "all";
      } else if (tab === 1) {
        url = `${API_BASE_URL}${eventSlug}/dashboard/customers`;
        params.filterType = "payment_completed";
      } else {
        url = `${API_BASE_URL}${eventSlug}/dashboard/attendees`;
      }

      const res = await axios.get(url, { params });
      if (res?.data?.success) {
        if (tab === 2) {
          this.setState({
            rows: res.data.data.attendees || [],
            total: res.data.data.total || 0,
            loading: false,
          });
        } else {
          this.setState({
            rows: res.data.data.customers || [],
            total: res.data.data.total || 0,
            loading: false,
          });
        }
      } else {
        this.setState({ rows: [], total: 0, loading: false });
      }
    } catch (e) {
      console.error("Dashboard fetch error", e);
      this.setState({ rows: [], total: 0, loading: false });
    }
  };

  handleTabChange = (_e, value) => {
    this.setState({ tab: value, page: 0 });
  };

  handleChangePage = (newPage) => {
    this.setState({ page: newPage });
  };

  handleChangeRowsPerPage = (newRowsPerPage) => {
    this.setState({ rowsPerPage: newRowsPerPage, page: 0 });
  };

  // QR Scanner methods
  handleOpenScanner = () => {
    this.setState({
      scannerOpen: true,
      scanResult: null,
      alreadyCheckedIn: false,
    });
  };

  handleCloseScanner = () => {
    this.setState({
      scannerOpen: false,
      scanResult: null,
      alreadyCheckedIn: false,
    });
  };

  fetchAttendeeByQR = async (ticketId) => {
    try {
      const { eventSlug } = this.state;

      // Call validate-qr endpoint to fetch attendee details
      const response = await axios.post(
        `${API_BASE_URL}${eventSlug}/validate-qr`,
        { ticketId },
        {
          headers: {
            "X-Request-Source": "superadmin",
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching attendee details:", error);
      throw error;
    }
  };

  handleQRScan = async (qrCodeData) => {
    try {
      const { eventSlug } = this.state;

      // Make API call to check-in endpoint
      const response = await axios.post(
        `${API_BASE_URL}${eventSlug}/checkin`,
        {
          qrCode: qrCodeData,
          checkedInBy: this.props.agent?.displayName || "Unknown",
          scannerName: "Event Dashboard",
        },
        {
          headers: {
            "X-Request-Source": "superadmin",
          },
        }
      );

      if (response.data.success) {
        this.setState({
          scanResult: response.data,
          alreadyCheckedIn: response.data.alreadyCheckedIn || false,
          snackbarMessage: response.data.alreadyCheckedIn
            ? "Attendee was already checked in"
            : "Check-in successful!",
          snackbarSeverity: "success",
          snackbarOpen: true,
        });

        // Refresh the attendees list if on that tab
        if (this.state.tab === 2) {
          setTimeout(() => {
            this.fetchData();
          }, 1000);
        }
      } else {
        throw new Error(response.data.message || "Check-in failed");
      }
    } catch (error) {
      console.error("Check-in error:", error);

      // Extract error message from backend
      const errorMessage =
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "Failed to check-in attendee";

      this.setState({
        scanResult: { success: false, message: errorMessage },
        snackbarMessage: errorMessage,
        snackbarSeverity: "error",
        snackbarOpen: true,
      });
    }
  };

  handleCloseSnackbar = () => {
    this.setState({ snackbarOpen: false });
  };

  // Search handlers
  handleSearchChange = (event) => {
    const query = event.target.value;

    // Clear existing timer
    if (this.state.searchDebounceTimer) {
      clearTimeout(this.state.searchDebounceTimer);
    }

    // Set new timer for debounced search
    const timer = setTimeout(() => {
      this.setState({ searchQuery: query });
    }, 500); // 500ms debounce

    this.setState({ searchDebounceTimer: timer });
  };

  handleClearSearch = () => {
    this.setState({ searchQuery: "", searchDebounceTimer: null });
  };

  // Manual check-in handlers
  handleOpenConfirmDialog = (attendee) => {
    this.setState({ confirmDialogOpen: true, selectedAttendee: attendee });
  };

  handleCloseConfirmDialog = () => {
    this.setState({ confirmDialogOpen: false, selectedAttendee: null });
  };

  handleConfirmCheckIn = async () => {
    try {
      const { selectedAttendee, eventSlug } = this.state;
      if (!selectedAttendee) return;

      this.setState({ checkingIn: true });

      // Create QR code data from ticket ID
      const qrCodeData = JSON.stringify({ tid: selectedAttendee.ticketId });

      const response = await axios.post(`${API_BASE_URL}${eventSlug}/checkin`, {
        qrCode: qrCodeData,
        checkedInBy: this.props.agent?.displayName || "Unknown",
        scannerName: "Manual Check-in",
      });

      if (response.data.success) {
        this.setState({
          snackbarMessage: response.data.alreadyCheckedIn
            ? "Attendee was already checked in"
            : "Check-in successful!",
          snackbarSeverity: "success",
          snackbarOpen: true,
          confirmDialogOpen: false,
          selectedAttendee: null,
          checkingIn: false,
        });

        // Refresh the attendees list
        setTimeout(() => {
          this.fetchData();
        }, 1000);
      } else {
        throw new Error(response.data.message || "Check-in failed");
      }
    } catch (error) {
      console.error("Manual check-in error:", error);

      const errorMessage =
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "Failed to check-in attendee";

      this.setState({
        snackbarMessage: errorMessage,
        snackbarSeverity: "error",
        snackbarOpen: true,
        checkingIn: false,
      });
    }
  };

  // Attendee details dialog handlers
  handleOpenDetailsDialog = (attendee) => {
    this.setState({
      detailsDialogOpen: true,
      selectedAttendeeForDetails: attendee,
    });
  };

  handleCloseDetailsDialog = () => {
    this.setState({
      detailsDialogOpen: false,
      selectedAttendeeForDetails: null,
    });
  };

  // Transaction details dialog handlers
  handleOpenTransactionDialog = (transaction) => {
    this.setState({
      transactionDialogOpen: true,
      selectedTransaction: transaction,
    });
  };

  handleCloseTransactionDialog = () => {
    this.setState({ transactionDialogOpen: false, selectedTransaction: null });
  };

  getColumns = () => {
    const { tab } = this.state;
    const { classes: styleClasses } = this.props;

    if (tab === 0) {
      return [
        {
          name: "Name",
          options: {
            customBodyRender: (value) => (
              <span style={{ fontWeight: 500 }}>{value || "—"}</span>
            ),
          },
        },
        { name: "Email" },
        {
          name: "Phone",
          options: {
            customBodyRender: (value) => (
              <span className={styleClasses.phoneText}>{value || "—"}</span>
            ),
          },
        },
        { name: "Organization" },
        { name: "Created At" },
      ];
    }

    if (tab === 1) {
      return [
        {
          name: "Name",
          options: {
            customBodyRender: (value) => (
              <span style={{ fontWeight: 500 }}>{value || "—"}</span>
            ),
          },
        },
        { name: "Email" },
        {
          name: "Phone",
          options: {
            customBodyRender: (value) => (
              <span className={styleClasses.phoneText}>{value || "—"}</span>
            ),
          },
        },
        { name: "Payment ID" },
        {
          name: "Amount",
          options: {
            customBodyRender: (value) => (
              <span className={styleClasses.amountText}>
                {typeof value === "number" ? `₹${value}` : "—"}
              </span>
            ),
          },
        },
        { name: "Payment Date" },
        { name: "Tickets Purchased" },
        { name: "Quantity" },
        {
          name: "View Details",
          options: {
            customBodyRender: (value, tableMeta) => {
              const row = this.state.rows[tableMeta.rowIndex];
              return (
                <Button
                  size="small"
                  variant="outlined"
                  color="primary"
                  onClick={(e) => {
                    e.stopPropagation();
                    this.handleOpenTransactionDialog(row);
                  }}
                  style={{
                    textTransform: "none",
                    fontWeight: 500,
                  }}
                >
                  View
                </Button>
              );
            },
            sort: false,
            filter: false,
          },
        },
      ];
    }

    // Attendees tab columns - horizontally scrollable on mobile
    return [
      {
        name: "Name",
        options: {
          customBodyRender: (value) => (
            <span
              style={{
                fontWeight: 600,
                wordBreak: "break-word",
                minWidth: 120,
              }}
            >
              {value || "—"}
            </span>
          ),
        },
      },
      {
        name: "Status",
        options: {
          customBodyRender: (value) => (
            <Chip
              label={value}
              size="small"
              className={styleClasses.statusChip}
              color={value === "Checked In" ? "primary" : "default"}
              style={{
                fontWeight: 600,
                fontSize: "0.75rem",
              }}
            />
          ),
        },
      },
      {
        name: "Email",
        options: {
          customBodyRender: (value) => (
            <span
              style={{
                fontSize: "0.85rem",
                wordBreak: "break-all",
                minWidth: 180,
              }}
            >
              {value || "—"}
            </span>
          ),
        },
      },
      {
        name: "Phone",
        options: {
          customBodyRender: (value) => (
            <span className={styleClasses.phoneText} style={{ minWidth: 120 }}>
              {value || "—"}
            </span>
          ),
        },
      },
      {
        name: "Organization",
        options: {
          customBodyRender: (value) => (
            <span style={{ fontSize: "0.85rem", minWidth: 150 }}>
              {value || "—"}
            </span>
          ),
        },
      },
      {
        name: "Designation",
        options: {
          customBodyRender: (value) => (
            <span style={{ fontSize: "0.85rem", minWidth: 130 }}>
              {value || "—"}
            </span>
          ),
        },
      },
      {
        name: "Ticket Type",
        options: {
          customBodyRender: (value) => (
            <span style={{ fontSize: "0.85rem", minWidth: 120 }}>
              {value || "—"}
            </span>
          ),
        },
      },
      {
        name: "Check-in Time",
        options: {
          customBodyRender: (value) => (
            <span style={{ fontSize: "0.85rem", minWidth: 160 }}>
              {value || "—"}
            </span>
          ),
        },
      },
      {
        name: "Check-in",
        options: {
          customBodyRender: (value, tableMeta) => {
            const row = this.state.rows[tableMeta.rowIndex];
            const isCheckedIn = row?.isCheckedIn;

            return (
              <Button
                size="small"
                variant="contained"
                className={styleClasses.checkInButton}
                onClick={(e) => {
                  e.stopPropagation();
                  this.handleOpenConfirmDialog(row);
                }}
                disabled={isCheckedIn}
                startIcon={<CheckInIcon className={styleClasses.checkInIcon} />}
              >
                {isCheckedIn ? "Done" : "Check-in"}
              </Button>
            );
          },
          sort: false,
          filter: false,
        },
      },
    ];
  };

  renderTableBody = () => {
    const { tab, rows } = this.state;

    if (tab === 0) {
      return rows.map((c) => [
        c.fullName || "—",
        c.email || "—",
        `${c.countryCallingCode ? c.countryCallingCode + " " : ""}${
          c.phone || ""
        }`,
        c.organizationName || "—",
        c.createdAt ? moment(c.createdAt).format("DD MMM YYYY, hh:mm A") : "—",
      ]);
    }

    if (tab === 1) {
      return (rows || []).map((c) => [
        c.fullName || "—",
        c.email || "—",
        `${c.countryCallingCode ? c.countryCallingCode + " " : ""}${
          c.phone || ""
        }`,
        c?.paymentIntent?.paymentId || "—",
        typeof c.finalAmount === "number" ? c.finalAmount : "—",
        c?.customerJourney?.paymentCompletedAt
          ? moment(c.customerJourney.paymentCompletedAt).format(
              "DD MMM YYYY, hh:mm A"
            )
          : "—",
        (c.tickets || []).map((t) => `${t.title} @ ₹${t.price}`).join(", ") ||
          "—",
        (c.tickets || []).map((t) => t.quantity).join(", ") || "—",
        "", // View Details button (rendered by customBodyRender)
      ]);
    }

    // Attendees tab - all columns with horizontal scroll
    return (rows || []).map((a) => [
      a.fullName || "—",
      a.isCheckedIn ? "Checked In" : "Pending",
      a.email || "—",
      `${a.countryCallingCode ? a.countryCallingCode + " " : ""}${
        a.phone || ""
      }`,
      a.organizationName || "—",
      a.designation || "—",
      a.ticketTitle || "—",
      a.checkInDetails?.checkedInAt
        ? moment(a.checkInDetails.checkedInAt).format("DD MMM, hh:mm A")
        : "—",
      "", // Check-in button (rendered by customBodyRender) - moved to last position
    ]);
  };

  render() {
    const { classes } = this.props;
    const {
      tab,
      loading,
      total,
      page,
      rowsPerPage,
      scannerOpen,
      scanResult,
      alreadyCheckedIn,
      snackbarOpen,
      snackbarMessage,
      snackbarSeverity,
      searchQuery,
      confirmDialogOpen,
      selectedAttendee,
      checkingIn,
      detailsDialogOpen,
      selectedAttendeeForDetails,
      transactionDialogOpen,
      selectedTransaction,
    } = this.state;

    const tabLabels = ["Form Submissions", "Transactions", "Attendees"];

    return (
      <Box className={classes.root}>
        <div className={classes.header}>
          <Typography variant="h4" className={classes.title}>
            Event Dashboard
          </Typography>
        </div>

        <Paper className={classes.tabsContainer} square={false}>
          <Tabs
            value={tab}
            onChange={this.handleTabChange}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
            className={classes.tabs}
          >
            {tabLabels.map((label, idx) => (
              <Tab key={idx} label={label} className={classes.tab} />
            ))}
          </Tabs>
        </Paper>

        {/* Search Bar */}
        <div className={classes.searchContainer}>
          <TextField
            className={classes.searchField}
            placeholder={
              tab === 0
                ? "Search by name, email, phone, organization..."
                : tab === 1
                ? "Search by name, email, phone, payment ID..."
                : "Search by name, email, phone, ticket ID..."
            }
            variant="outlined"
            size="small"
            defaultValue={searchQuery}
            onChange={this.handleSearchChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon color="action" />
                </InputAdornment>
              ),
              endAdornment: searchQuery && (
                <InputAdornment position="end">
                  <IconButton size="small" onClick={this.handleClearSearch}>
                    <ClearIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </div>

        <Paper className={classes.tablePaper} square={false}>
          {loading && (
            <div className={classes.loadingOverlay}>
              <CircularProgress size={48} />
            </div>
          )}

          {/* horizontal scroll wrapper */}
          <div className={classes.tableScrollX}>
            <MUIDataTable
              title=""
              data={this.renderTableBody()}
              columns={this.getColumns()}
              options={{
                elevation: 0,
                filter: false,
                search: false,
                print: false,
                download: false,
                viewColumns: false,
                selectableRows: "none",

                // Force standard table layout with horizontal scroll on mobile
                responsive: "standard",
                tableBodyHeight: "auto",
                tableBodyMaxHeight: "70vh",

                serverSide: true,
                rowsPerPage: rowsPerPage,
                rowsPerPageOptions: [10],
                count: total,
                page: page,
                pagination: true,
                onChangePage: this.handleChangePage,
                onChangeRowsPerPage: this.handleChangeRowsPerPage,

                // Force table layout to maintain columns
                setTableProps: () => ({
                  size: "small",
                  style: {
                    tableLayout: "auto",
                    width: "100%",
                    minWidth: "800px", // Minimum width to force horizontal scroll
                  },
                }),

                textLabels: {
                  body: { noMatch: loading ? "Loading..." : "No data found" },
                  pagination: { rowsPerPage: "Rows:" },
                },
                setRowProps: (_row, dataIndex) => ({
                  style: {
                    backgroundColor: dataIndex % 2 ? "#fafbfc" : "#fff",
                    transition: "background-color 0.2s ease",
                  },
                  className: tab === 2 ? classes.clickableRow : "",
                }),
                onRowClick: (rowData, rowMeta) => {
                  if (tab === 2) {
                    // Only for attendees tab
                    const attendee = this.state.rows[rowMeta.dataIndex];
                    this.handleOpenDetailsDialog(attendee);
                  }
                },
              }}
            />
          </div>
        </Paper>

        {/* Floating QR Scanner Button */}
        <div className={classes.fabContainer}>
          <Fab
            variant="extended"
            className={classes.fab}
            onClick={this.handleOpenScanner}
            aria-label="scan qr code"
          >
            <QrCodeIcon />
            <span className={classes.fabLabel}>Scan QR</span>
          </Fab>
        </div>

        {/* QR Scanner Dialog */}
        <QRScanner
          open={scannerOpen}
          onClose={this.handleCloseScanner}
          onScan={this.handleQRScan}
          fetchAttendeeByQR={this.fetchAttendeeByQR}
          result={scanResult}
          alreadyCheckedIn={alreadyCheckedIn}
        />

        {/* Manual Check-in Confirmation Dialog */}
        <Dialog
          open={confirmDialogOpen}
          onClose={this.handleCloseConfirmDialog}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle className={classes.dialogTitle}>
            Confirm Check-in
          </DialogTitle>
          <DialogContent className={classes.dialogContent}>
            <Typography variant="body2" color="textSecondary" gutterBottom>
              Please confirm you want to check in this attendee:
            </Typography>

            {selectedAttendee && (
              <Box className={classes.attendeeInfo}>
                <div className={classes.infoRow}>
                  <span className={classes.infoLabel}>Name:</span>
                  <span className={classes.infoValue}>
                    {selectedAttendee.fullName}
                  </span>
                </div>
                <div className={classes.infoRow}>
                  <span className={classes.infoLabel}>Email:</span>
                  <span className={classes.infoValue}>
                    {selectedAttendee.email}
                  </span>
                </div>
                <div className={classes.infoRow}>
                  <span className={classes.infoLabel}>Phone:</span>
                  <span className={classes.infoValue}>
                    {selectedAttendee.countryCallingCode}{" "}
                    {selectedAttendee.phone}
                  </span>
                </div>
                {selectedAttendee.organizationName && (
                  <div className={classes.infoRow}>
                    <span className={classes.infoLabel}>Organization:</span>
                    <span className={classes.infoValue}>
                      {selectedAttendee.organizationName}
                    </span>
                  </div>
                )}
                <div className={classes.infoRow}>
                  <span className={classes.infoLabel}>Ticket Type:</span>
                  <span className={classes.infoValue}>
                    {selectedAttendee.ticketTitle}
                  </span>
                </div>
              </Box>
            )}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.handleCloseConfirmDialog}
              disabled={checkingIn}
            >
              Cancel
            </Button>
            <Button
              onClick={this.handleConfirmCheckIn}
              color="primary"
              variant="contained"
              disabled={checkingIn}
            >
              {checkingIn ? <CircularProgress size={20} /> : "Confirm Check-in"}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Attendee Details Dialog */}
        <Dialog
          open={detailsDialogOpen}
          onClose={this.handleCloseDetailsDialog}
          maxWidth="md"
          fullWidth
          classes={{ paper: classes.detailsDialogPaper }}
        >
          <DialogTitle className={classes.detailsDialogTitle} disableTypography>
            <Typography variant="h6" style={{ fontWeight: 700 }}>
              Attendee Details
            </Typography>
          </DialogTitle>
          <DialogContent style={{ padding: "24px" }}>
            {selectedAttendeeForDetails && (
              <>
                {/* Personal Information */}
                <Box className={classes.detailsSection}>
                  <Typography className={classes.sectionTitle}>
                    Personal Information
                  </Typography>
                  <div className={classes.infoRow}>
                    <span className={classes.infoLabel}>Full Name:</span>
                    <span className={classes.infoValue}>
                      {selectedAttendeeForDetails.fullName}
                    </span>
                  </div>
                  <div className={classes.infoRow}>
                    <span className={classes.infoLabel}>Email:</span>
                    <span className={classes.infoValue}>
                      {selectedAttendeeForDetails.email}
                    </span>
                  </div>
                  <div className={classes.infoRow}>
                    <span className={classes.infoLabel}>Phone:</span>
                    <span className={classes.infoValue}>
                      {selectedAttendeeForDetails.countryCallingCode}{" "}
                      {selectedAttendeeForDetails.phone}
                    </span>
                  </div>
                  {selectedAttendeeForDetails.designation && (
                    <div className={classes.infoRow}>
                      <span className={classes.infoLabel}>Designation:</span>
                      <span className={classes.infoValue}>
                        {selectedAttendeeForDetails.designation}
                      </span>
                    </div>
                  )}
                </Box>

                {/* Organization Information */}
                {(selectedAttendeeForDetails.organizationName ||
                  selectedAttendeeForDetails.organizationSize ||
                  selectedAttendeeForDetails.industry) && (
                  <Box className={classes.detailsSection}>
                    <Typography className={classes.sectionTitle}>
                      Organization Information
                    </Typography>
                    {selectedAttendeeForDetails.organizationName && (
                      <div className={classes.infoRow}>
                        <span className={classes.infoLabel}>Organization:</span>
                        <span className={classes.infoValue}>
                          {selectedAttendeeForDetails.organizationName}
                        </span>
                      </div>
                    )}
                    {selectedAttendeeForDetails.organizationSize && (
                      <div className={classes.infoRow}>
                        <span className={classes.infoLabel}>
                          Organization Size:
                        </span>
                        <span className={classes.infoValue}>
                          {selectedAttendeeForDetails.organizationSize}
                        </span>
                      </div>
                    )}
                    {selectedAttendeeForDetails.industry && (
                      <div className={classes.infoRow}>
                        <span className={classes.infoLabel}>Industry:</span>
                        <span className={classes.infoValue}>
                          {selectedAttendeeForDetails.industry}
                        </span>
                      </div>
                    )}
                  </Box>
                )}

                {/* Ticket Information */}
                <Box className={classes.detailsSection}>
                  <Typography className={classes.sectionTitle}>
                    Ticket Information
                  </Typography>
                  <div className={classes.infoRow}>
                    <span className={classes.infoLabel}>Ticket ID:</span>
                    <span
                      className={classes.infoValue}
                      style={{ fontFamily: "monospace" }}
                    >
                      {selectedAttendeeForDetails.ticketId}
                    </span>
                  </div>
                  <div className={classes.infoRow}>
                    <span className={classes.infoLabel}>Ticket Type:</span>
                    <span className={classes.infoValue}>
                      {selectedAttendeeForDetails.ticketTitle}
                    </span>
                  </div>
                  <div className={classes.infoRow}>
                    <span className={classes.infoLabel}>Event:</span>
                    <span className={classes.infoValue}>
                      {selectedAttendeeForDetails.eventName}
                    </span>
                  </div>
                  <div className={classes.infoRow}>
                    <span className={classes.infoLabel}>Location:</span>
                    <span className={classes.infoValue}>
                      {selectedAttendeeForDetails.location}
                    </span>
                  </div>
                </Box>

                {/* Check-in Information */}
                <Box className={classes.detailsSection}>
                  <Typography className={classes.sectionTitle}>
                    Check-in Information
                  </Typography>
                  <div className={classes.infoRow}>
                    <span className={classes.infoLabel}>Status:</span>
                    <span>
                      <Chip
                        label={
                          selectedAttendeeForDetails.isCheckedIn
                            ? "Checked In"
                            : "Pending"
                        }
                        color={
                          selectedAttendeeForDetails.isCheckedIn
                            ? "primary"
                            : "default"
                        }
                        size="small"
                        style={{ fontWeight: 600 }}
                      />
                    </span>
                  </div>
                  {selectedAttendeeForDetails.checkInDetails?.checkedInAt && (
                    <>
                      <div className={classes.infoRow}>
                        <span className={classes.infoLabel}>
                          Checked-in At:
                        </span>
                        <span className={classes.infoValue}>
                          {moment(
                            selectedAttendeeForDetails.checkInDetails
                              .checkedInAt
                          ).format("DD MMM YYYY, hh:mm:ss A")}
                        </span>
                      </div>
                      {selectedAttendeeForDetails.checkInDetails
                        .checkedInBy && (
                        <div className={classes.infoRow}>
                          <span className={classes.infoLabel}>
                            Checked-in By:
                          </span>
                          <span className={classes.infoValue}>
                            {
                              selectedAttendeeForDetails.checkInDetails
                                .checkedInBy
                            }
                          </span>
                        </div>
                      )}
                      {selectedAttendeeForDetails.checkInDetails
                        .scannerName && (
                        <div className={classes.infoRow}>
                          <span className={classes.infoLabel}>
                            Scanner Name:
                          </span>
                          <span className={classes.infoValue}>
                            {
                              selectedAttendeeForDetails.checkInDetails
                                .scannerName
                            }
                          </span>
                        </div>
                      )}
                    </>
                  )}
                </Box>

                {/* Registration Details */}
                <Box className={classes.detailsSection}>
                  <Typography className={classes.sectionTitle}>
                    Registration Details
                  </Typography>
                  <div className={classes.infoRow}>
                    <span className={classes.infoLabel}>Registered At:</span>
                    <span className={classes.infoValue}>
                      {moment(selectedAttendeeForDetails.createdAt).format(
                        "DD MMM YYYY, hh:mm A"
                      )}
                    </span>
                  </div>
                  <div className={classes.infoRow}>
                    <span className={classes.infoLabel}>Source:</span>
                    <span className={classes.infoValue}>
                      {selectedAttendeeForDetails.registrationSource || "form"}
                    </span>
                  </div>
                </Box>
              </>
            )}
          </DialogContent>
          <DialogActions style={{ padding: "16px 24px" }}>
            <Button onClick={this.handleCloseDetailsDialog} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>

        {/* Transaction Details Dialog */}
        <Dialog
          open={transactionDialogOpen}
          onClose={this.handleCloseTransactionDialog}
          maxWidth="md"
          fullWidth
          classes={{ paper: classes.transactionDialogPaper }}
        >
          <DialogTitle
            className={classes.transactionDialogTitle}
            disableTypography
          >
            <ReceiptIcon style={{ fontSize: 28 }} />
            <Typography variant="h6" style={{ fontWeight: 700 }}>
              Transaction Details
            </Typography>
          </DialogTitle>
          <DialogContent style={{ padding: "24px" }}>
            {selectedTransaction && (
              <>
                {/* Customer Information */}
                <Box className={classes.transactionSection}>
                  <Typography className={classes.transactionSectionTitle}>
                    Customer Information
                  </Typography>
                  <div className={classes.transactionInfoRow}>
                    <span className={classes.transactionInfoLabel}>Name:</span>
                    <span className={classes.transactionInfoValue}>
                      {selectedTransaction.fullName}
                    </span>
                  </div>
                  <div className={classes.transactionInfoRow}>
                    <span className={classes.transactionInfoLabel}>Email:</span>
                    <span className={classes.transactionInfoValue}>
                      {selectedTransaction.email}
                    </span>
                  </div>
                  <div className={classes.transactionInfoRow}>
                    <span className={classes.transactionInfoLabel}>Phone:</span>
                    <span className={classes.transactionInfoValue}>
                      {selectedTransaction.countryCallingCode}{" "}
                      {selectedTransaction.phone}
                    </span>
                  </div>
                  {selectedTransaction.organizationName && (
                    <div className={classes.transactionInfoRow}>
                      <span className={classes.transactionInfoLabel}>
                        Organization:
                      </span>
                      <span className={classes.transactionInfoValue}>
                        {selectedTransaction.organizationName}
                      </span>
                    </div>
                  )}
                </Box>

                {/* Payment Information */}
                <Box className={classes.transactionSection}>
                  <Typography className={classes.transactionSectionTitle}>
                    Payment Information
                  </Typography>
                  <div className={classes.transactionInfoRow}>
                    <span className={classes.transactionInfoLabel}>
                      Payment ID:
                    </span>
                    <span
                      className={classes.transactionInfoValue}
                      style={{ fontFamily: "monospace", fontSize: "0.8rem" }}
                    >
                      {selectedTransaction.paymentIntent?.paymentId || "—"}
                    </span>
                  </div>
                  <div className={classes.transactionInfoRow}>
                    <span className={classes.transactionInfoLabel}>
                      Order ID:
                    </span>
                    <span
                      className={classes.transactionInfoValue}
                      style={{ fontFamily: "monospace", fontSize: "0.8rem" }}
                    >
                      {selectedTransaction.paymentIntent?.razorpayOrderId ||
                        "—"}
                    </span>
                  </div>
                  <div className={classes.transactionInfoRow}>
                    <span className={classes.transactionInfoLabel}>
                      Amount:
                    </span>
                    <span
                      className={classes.transactionInfoValue}
                      style={{ fontWeight: 700, color: "#10b981" }}
                    >
                      ₹{selectedTransaction.finalAmount}
                    </span>
                  </div>
                  {selectedTransaction.discount > 0 && (
                    <>
                      <div className={classes.transactionInfoRow}>
                        <span className={classes.transactionInfoLabel}>
                          Subtotal:
                        </span>
                        <span className={classes.transactionInfoValue}>
                          ₹{selectedTransaction.subtotal}
                        </span>
                      </div>
                      <div className={classes.transactionInfoRow}>
                        <span className={classes.transactionInfoLabel}>
                          Discount:
                        </span>
                        <span
                          className={classes.transactionInfoValue}
                          style={{ color: "#ef4444" }}
                        >
                          - ₹{selectedTransaction.discount}
                        </span>
                      </div>
                    </>
                  )}
                  {/* {selectedTransaction.couponDetails?.code && (
                    <div className={classes.transactionInfoRow}>
                      <span className={classes.transactionInfoLabel}>
                        Coupon Code:
                      </span>
                      <span
                        className={classes.transactionInfoValue}
                        style={{ fontWeight: 600, color: "#10b981" }}
                      >
                        {selectedTransaction.couponDetails.code}
                      </span>
                    </div>
                  )} */}
                  <div className={classes.transactionInfoRow}>
                    <span className={classes.transactionInfoLabel}>
                      Payment Date:
                    </span>
                    <span className={classes.transactionInfoValue}>
                      {selectedTransaction.customerJourney?.paymentCompletedAt
                        ? moment(
                            selectedTransaction.customerJourney
                              .paymentCompletedAt
                          ).format("DD MMM YYYY, hh:mm A")
                        : "—"}
                    </span>
                  </div>
                  {selectedTransaction.paymentMethod && (
                    <div className={classes.transactionInfoRow}>
                      <span className={classes.transactionInfoLabel}>
                        Payment Method:
                      </span>
                      <span className={classes.transactionInfoValue}>
                        {selectedTransaction.paymentMethod}
                      </span>
                    </div>
                  )}
                </Box>

                {/* Tickets Information */}
                <Box className={classes.transactionSection}>
                  <Typography className={classes.transactionSectionTitle}>
                    Tickets
                  </Typography>
                  <div className={classes.transactionInfoRow}>
                    <span className={classes.transactionInfoLabel}>
                      Total Attendees:
                    </span>
                    <span className={classes.transactionInfoValue}>
                      {selectedTransaction.totalAttendees}
                    </span>
                  </div>
                  {selectedTransaction.tickets &&
                    selectedTransaction.tickets.map((ticket, index) => (
                      <div
                        key={index}
                        className={classes.transactionInfoRow}
                        style={{
                          padding: "8px",
                          backgroundColor: "#f1f5f9",
                          borderRadius: 4,
                          marginTop: 8,
                        }}
                      >
                        <span className={classes.transactionInfoLabel}>
                          {ticket.title}:
                        </span>
                        <span className={classes.transactionInfoValue}>
                          {ticket.quantity} × ₹{ticket.price} = ₹
                          {ticket.quantity * ticket.price}
                        </span>
                      </div>
                    ))}
                </Box>

                {/* Links Section */}
                <Box className={classes.transactionSection}>
                  <Typography className={classes.transactionSectionTitle}>
                    Quick Links
                  </Typography>
                  {/* Checkout/Thank You Page Link */}
                  <a
                    href={`https://checkout.aisensy.com/${selectedTransaction.eventSlug}/thankyou?customerId=${selectedTransaction._id}&orderId=${selectedTransaction.paymentIntent?.razorpayOrderId}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={classes.linkButton}
                  >
                    <OpenInNewIcon style={{ fontSize: 18 }} />
                    View QR Page
                  </a>

                  {/* Invoice Link */}
                  {selectedTransaction.invoiceDetails?.invoiceLink && (
                    <a
                      href={selectedTransaction.invoiceDetails.invoiceLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={classes.linkButton}
                    >
                      <ReceiptIcon style={{ fontSize: 18 }} />
                      View Invoice
                    </a>
                  )}

                  {/* PDF Link */}
                  {/* {selectedTransaction.invoiceDetails?.pdfLink && (
                    <a
                      href={selectedTransaction.invoiceDetails.pdfLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={classes.linkButton}
                    >
                      <OpenInNewIcon style={{ fontSize: 18 }} />
                      Download Invoice PDF
                    </a>
                  )} */}
                </Box>
              </>
            )}
          </DialogContent>
          <DialogActions style={{ padding: "16px 24px" }}>
            <Button
              onClick={this.handleCloseTransactionDialog}
              color="primary"
              variant="contained"
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>

        {/* Snackbar for notifications */}
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={4000}
          onClose={this.handleCloseSnackbar}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <SnackbarContent
            className={
              snackbarSeverity === "success"
                ? classes.snackbarSuccess
                : classes.snackbarError
            }
            message={
              <span style={{ display: "flex", alignItems: "center" }}>
                {snackbarSeverity === "success" ? (
                  <CheckCircle className={classes.snackbarIcon} />
                ) : (
                  <Error className={classes.snackbarIcon} />
                )}
                {snackbarMessage}
              </span>
            }
          />
        </Snackbar>
      </Box>
    );
  }
}

const connectEventDashboard = connect((state) => ({
  agent: state.login.user,
}))(EventDashboard);

export default withStyles(styles)(connectEventDashboard);
